import { iChing, diaChi, diaChiNguHanh, nguHanh } from './i-ching'
import { CAN, getDataLunar } from '../calender'
import { dichCung } from '../tuvi/amduong'

const tienthien = [1, 8, 7, 3, 6, 4, 5, 2]
const LUC_THU = ['Thanh Long', 'Chu Tước', 'Câu Trận', 'Đằng Xà', 'Bạch Hổ', 'Huyền Vũ']
const LUC_THU_NGU_HANH = [4, 5, 1, 1, 2, 3]
const VONG_TRUONG_SINH = ['T.Sinh', 'M.Dục', 'Q.Đới', 'L.Quan', 'Đ.Vượng', 'Suy', 'Bệnh', 'Tử', 'Mộ', 'Tuyệt', 'Thai', 'Dưỡng']
const KHOI_TRUONG_SINH = [3, 6, 9, 12, 3] // hoa tho dong cuc
const KHOI_TRUONG_SINH_2 = [9, 6, 9, 12, 3] // thuy tho dong cuc
// Tinh loc theo can ngay/thang
const LOC = ['Dần', 'Mão', 'Tị', 'Ngọ', 'Tị', 'Ngọ', 'Thân', 'Dậu', 'Tý', 'Hợi']
// Tinh ma theo chi ngay/thang
const MA = ['Dần', 'Hợi', 'Thân', 'Tị', 'Dần', 'Hợi', 'Thân', 'Tị', 'Dần', 'Hợi', 'Thân', 'Tị']
// Tinh quy nhan theo can ngay/thang
const QUY = ['Sửu', 'Thân', 'Hợi', 'Dậu', 'Sửu', 'Thân', 'Ngọ', 'Dần', 'Mão', 'Tị']
// Tinh dao theo chi ngay/thang
const DAO = ['Dậu', 'Ngọ', 'Mão', 'Tý', 'Dậu', 'Ngọ', 'Mão', 'Tý', 'Dậu', 'Ngọ', 'Mão', 'Tý']

const getDayMonthTk = (diachi) => {
  const name = diachi.split(' ')[1]
  const value = diaChi.indexOf(name)
  const nguhanhIndex = diaChiNguHanh[value]
  const nguhanh = nguHanh[nguhanhIndex - 1]
  return { name, value, nguhanhIndex, nguhanh }
}

const getLucThu = (canNgay) => {
  const canNgayIndex = CAN.indexOf(canNgay)
  let offset = 0
  switch (canNgayIndex) {
    case 0:
    case 1:
      offset = 0
      break
    case 2:
    case 3:
      offset = 1
      break
    case 4:
      offset = 2
      break
    case 5:
      offset = 3
      break
    case 6:
    case 7:
      offset = 4
      break
    case 8:
    case 9:
      offset = 5
      break
  }
  const lucthu = []
  const color = []
  for (let i = 0; i < LUC_THU.length; i++) {
    const pos = (i + offset) % 6
    lucthu.push(LUC_THU[pos])
    color.push(`color_${LUC_THU_NGU_HANH[pos]}`)
  }
  return {
    name: lucthu.reverse(),
    color: color.reverse()
  }
}

const getVuongSuy = (nguhanhIndex, nguyetlenh) => {
  const nguyetlenhNguHanh = diaChiNguHanh[diaChi.indexOf(nguyetlenh)]
  switch (nguhanhIndex - nguyetlenhNguHanh) {
    case 0:
      return 'Vượng'
    case -1:
    case 4:
      return 'Hưu'
    case -2:
    case 3:
      return 'Tù'
    case 1:
    case -4:
      return 'Tướng'
    case 2:
    case -3:
      return 'Tử'
  }
}

const getVongTS = (nguhanhIndex, nhatthan, isHoaTho) => {
  const tmpNhatThan = nhatthan + 1
  const khoiTruongSinh = isHoaTho ? KHOI_TRUONG_SINH[nguhanhIndex - 1] : KHOI_TRUONG_SINH_2[nguhanhIndex - 1]
  const vitriTruongSinh = tmpNhatThan < khoiTruongSinh ? (11 + tmpNhatThan - khoiTruongSinh) : tmpNhatThan - khoiTruongSinh - 1
  if (tmpNhatThan === khoiTruongSinh) {
    return VONG_TRUONG_SINH[0]
  }
  return VONG_TRUONG_SINH[vitriTruongSinh + 1]
}

const getAmDong = (nhatthan, nguyenkien) => {
  const tmp = nhatthan.value + 1 + 6
  const haoxung = tmp > 12 ? tmp % 12 : tmp
  const haoxungNguHanh = diaChiNguHanh[haoxung - 1]
  if ([-4, 0, 1].includes(haoxungNguHanh - nguyenkien.nguhanhIndex)) {
    return diaChi[haoxung - 1]
  }
  return null
}

export const anLucHao = (dd, mm, yyyy, hour, minute, isHoaTho, seri, curLine, lines) => {
  const { al, alTk } = getDataLunar(mm, yyyy, dd, hour, minute)

  const nhatThan = getDayMonthTk(alTk.day.name)
  const nguyetKien = getDayMonthTk(alTk.month.name)
  const [canNgay, chiNgay] = al.day.name.split(' ')
  const [canNgayIndex, chiNgayIndex] = [CAN.indexOf(canNgay), diaChi.indexOf(chiNgay)]

  // get Tuần
  const ketThucTuan = dichCung(diaChi.indexOf(chiNgay), 10 - CAN.indexOf(canNgay))
  const viTriTuan1 = dichCung(ketThucTuan, 1)
  const viTriTuan2 = dichCung(viTriTuan1, 1)
  const tuan = [diaChi[viTriTuan1 - 1], diaChi[viTriTuan2 - 1]]

  let hexagram = iChing.findHexagram(curLine ?? [1, 1, 1, 1, 1, 1])
  if (seri) {
    const numberCenter = Math.floor(seri.length / 2)
    let numberThuong = 0
    let numberHa = 0
    for (let i = 0; i < seri.length; i++) {
      if (i <= numberCenter - 1) {
        numberHa += parseInt(seri[i], 10)
      } else {
        numberThuong += parseInt(seri[i], 10)
      }
    }
    let thuongId = numberThuong > 8 ? numberThuong % 8 : numberThuong
    if (thuongId === 0) {
      thuongId = 8
    }
    const thuong = tienthien[thuongId - 1]
    const trigramThuong = iChing.trigram(thuong)
    let haId = numberHa > 8 ? numberHa % 8 : numberHa
    if (haId === 0) {
      haId = 8
    }
    const ha = tienthien[haId - 1]
    const trigramHa = iChing.trigram(ha)
    hexagram = iChing.findHexagram([...trigramThuong.lines, ...trigramHa.lines])
    const total = numberThuong + numberHa
    const haodong = total > 6 ? (total % 6 !== 0 ? total % 6 : 6) : total
    lines = hexagram.lines.map((line, index) => index === (haodong - 1) ? 1 : 0)
  }
  const changeLines = hexagram.changeLines(lines ?? [0, 0, 0, 0, 0, 0])
  const dataQue = {
    ...changeLines,
    changeLines: lines,
    lucthu: getLucThu(canNgay),
    from: {
      ...changeLines.from,
      tk: changeLines.from.diachi.map((diachi) => tuan.includes(diachi)),
      vuongsuy: changeLines.from.nguhanhIndex.map((nguhanhIndex) => getVuongSuy(nguhanhIndex, nguyetKien.name)),
      ts: changeLines.from.nguhanhIndex.map((nguhanhIndex) => getVongTS(nguhanhIndex, nhatThan.value, isHoaTho))
    },
    to: {
      ...changeLines.to,
      tk: changeLines.to.diachi.map((diachi) => tuan.includes(diachi)),
      vuongsuy: changeLines.to.nguhanhIndex.map((nguhanhIndex) => getVuongSuy(nguhanhIndex, nguyetKien.name)),
      ts: changeLines.to.nguhanhIndex.map((nguhanhIndex) => getVongTS(nguhanhIndex, nhatThan.value, isHoaTho))
    },
    loc: [LOC[canNgayIndex]],
    ma: [MA[chiNgayIndex]],
    quy: [QUY[canNgayIndex]],
    dao: [DAO[chiNgayIndex]],
    amdong: getAmDong(nhatThan, nguyetKien)
  }
  // console.log(dataQue)
  return {
    al,
    alTk,
    nhatThan,
    nguyetKien,
    dataQue
  }
}
